import * as React from "react";
import {cx} from 'emotion';

import "./order-history-expansion.scss";

import {
    ComponentLink,
    ComponentNext,
    makeChain,
    valueHelper as value,
}   from "@Common/react/cst2";

import {RangeLoader}           from "@Common/react/range-loader";
import {UseState}              from "@Common/react/use-state";
import {Types}                 from "@Common/types";

import {ItemCard}              from "./item-card/item-card";
import {ItemAttributesService} from "../item-attributes";

type Cart = Types.Apis.Payloads.Next.Item.GetHistory.Cart

export const OrderHistoryExpansion = ({cart, collapsed, cartObject}:{
    cart        : Types.Apis.Payloads.Next.Item.GetHistory.Cart,
    collapsed   : boolean,
    cartObject  : ComponentNext<typeof RangeLoader<Types.Apis.Payloads.Next.Item.GetHistory.Response, Cart>>
}) => ({
    render: ({colCount}) => !collapsed && (
        makeChain<JSX.Element>()
        .then("itemAttributesService", ({}, next:ComponentLink<typeof ItemAttributesService, "renderChildren">) => (
            ItemAttributesService({cart, renderChildren: next, onItemCancelled: cartObject.reload})
        ))
        .then("kitCollapsedState", (_, next:ComponentLink<typeof UseState<number[]>>) => UseState({
            initValue: [],
            next,
        }))
        .then("itemCards", value(({itemAttributesService: {mapItemAsAttributes}, kitCollapsedState}) => (
            cart.items.map((item) => (
                <ItemCard
                    key={item.itemId}
                    attributes={mapItemAsAttributes(item)}
                    item={item}
                    kitCollapsedState={kitCollapsedState}
                />
            ))
        )))
        .then(({itemCards}) => (
            <tr className={cx("order-history-expansion-p3d", {collapsed})}>
                <td colSpan={colCount}>
                    <div className={"grey-box"}>
                       {itemCards}
                    </div>
                </td>
            </tr>
        ))
        .run()
    )
});

